import React from "react";
import Navbar from "../component/Navbar";
import Jumbutron from "../component/Jumbutron";
import Plans from "../component/Plans";
import Calltoaction from "../component/Calltoaction";
import Footer from "../component/Footer";
import Webimagefooter from "../component/Webimagefooter";
import FAQSection from "../component/FAQSection";
import BlogPreview from "../component/BlogPreview";

function Home() {
  return (
    <div className="w-full">
      <Navbar />
      <Jumbutron />
      <Plans />
      <Calltoaction />
      <FAQSection/>
      <BlogPreview/>
      <Footer />
    
    </div>
  );
}

export default Home;
